import React from 'react';
import { Typography } from 'antd';
import type { DeckProgress } from '../services/deckStatus.js';

const { Text } = Typography;

const LEARNING = '#16a34a';
const KNOWN = '#1677ff';

/** The deck's progress: learning (green), known (blue), the rest to go (grey), with its legend. */
export const DeckProgressBar: React.FC<{ progress: DeckProgress | null; legend?: boolean }> = ({
  progress,
  legend = true,
}) => {
  const total = progress?.total ?? 0;
  const pct = (n: number) => (total > 0 ? (n / total) * 100 : 0);
  const label = progress
    ? `${progress.learning} learning, ${progress.known} known, ${progress.toGo} to go`
    : 'Loading progress';
  return (
    <div>
      <div
        role="img"
        aria-label={label}
        style={{
          display: 'flex',
          height: 8,
          borderRadius: 4,
          overflow: 'hidden',
          background: '#e5e7eb',
        }}
      >
        {progress && (
          <>
            <div style={{ width: `${pct(progress.learning)}%`, background: LEARNING }} />
            <div style={{ width: `${pct(progress.known)}%`, background: KNOWN }} />
          </>
        )}
      </div>
      {legend && progress && (
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 8, fontSize: 13 }}>
          <Text type="secondary">
            <Dot color={LEARNING} />
            {progress.learning} learning
          </Text>
          <Text type="secondary">
            <Dot color={KNOWN} />
            {progress.known} known
          </Text>
          <Text type="secondary">{progress.toGo} to go</Text>
        </div>
      )}
    </div>
  );
};

const Dot: React.FC<{ color: string }> = ({ color }) => (
  <span
    aria-hidden="true"
    style={{
      display: 'inline-block',
      width: 8,
      height: 8,
      borderRadius: '50%',
      background: color,
      marginRight: 6,
    }}
  />
);
